"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKIN_AI_PROCESSING_TYPES = exports.SKIN_AI_ANALYSIS_TYPES = void 0;
exports.SKIN_AI_ANALYSIS_TYPES = {
    face: 'face',
    regional: 'regional',
};
exports.SKIN_AI_PROCESSING_TYPES = {
    llm: 'llm',
    deterministic: 'deterministic',
};
//# sourceMappingURL=skinAi.js.map